import { render, staticRenderFns } from "./projectlist.vue?vue&type=template&id=c104d7f6&scoped=true&"
import script from "./projectlist.vue?vue&type=script&lang=js&"
export * from "./projectlist.vue?vue&type=script&lang=js&"
import style0 from "./projectlist.vue?vue&type=style&index=0&id=c104d7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c104d7f6",
  null
  
)

export default component.exports